$(document).ready(function() {

    if ($('.ttgKatalogList').length) {

        /*************** STÜCKMODUS BEI KATALOGEN **************/
        var stkMode = false;

        if ($("#ttgKatalogForm").data("stueckmodus")) {
            stkMode = true;
        }
        /*************** STÜCKMODUS BEI KATALOGEN **************/

        /*************** KATALOGE IN DIE RECHTE SPALTE ÜBERTRAGEN **************/

        $(".ttgKatalogListItemCheckbox").click(function() {

            // Check ob der Katalog schon ausgewählt worden ist
            if ($('#ttgCheckedCat' + $(this).attr('data-catid')).length) {

                // wenn vorhanden, den Katalog entfernen
                $('#ttgCheckedCat' + $(this).attr('data-catid')).parent().remove();

            } else {

                var stk = 1;
                var stkSuffix = "<span class='mr-2'>" + stk + "</span>";
                if (stkMode) {
                    stk = 1;
                    stkSuffix = "<input id='cat" + $(this).attr('data-catid') + "' type='text' class='stk ttgStueckInput mr-2' value='" + stk + "' onChange=\"$(this).parent().attr('data-catStk',$(this).val())\" /> ";
                }

                // Fehlermeldung ausblenden
                $('#ttgKatalogError').hide();

                // wenn nicht vorhanden, den Katalog hinzufügen
                $('<div class="ttgKatalogWrapper"><button class="ttgRemoveKatalog ttgKatalogRemoveIconRight" onclick="ttgRemoveKatalog(' + $(this).attr('data-catid') + ');"><span class="fas fa-trash fa-fw" aria-hidden="true"></span><span class="sr-only">' + $(this).attr('data-katalog') + ' "' + $(this).attr('data-cattitle') + '" ' + $(this).attr('data-entfernen') + '</span></button><div id="ttgCheckedCat' + $(this).attr('data-catid') + '" data-catStk="' + stk + '" class="ttgAddedKatalog" data-catid="' + $(this).attr('data-catid') + '" data-catlang="' + $(this).attr('data-catlang') + '" data-catcrm="' + $(this).attr('data-catcrm') + '" data-cattitle="' + $(this).attr('data-cattitle') + '">' + stkSuffix + '<label for="cat' + $(this).attr('data-catid') + '"><span class="sr-only">Stück</span>' + $(this).attr('data-cattitle') + '</label></div></div>').appendTo('.ttgKatalogbestellungAuswahl');
            }

        });

        /*************** KATALOGE IN DIE RECHTE SPALTE ÜBERTRAGEN **************/


        /*************** SUBMIT **************/
        $("#ttgKatalogForm").submit(function(e) {
            if ($(this).find('ul.filled').length != 0) {
                e.preventDefault();
            } else {

                // Das versteckte Feld mit den Katalogen befüllen
                var kataloge = "";

                $('.ttgAddedKatalog').each(function() {
                    kataloge = kataloge + $(this).attr('data-catid') + "||" + $(this).attr('data-catcrm') + "||" + $(this).attr('data-catStk') + "x||" + $(this).attr('data-cattitle') + "||" + $(this).attr('data-catlang') + "###";
                });

                $('#ttgKatalogForm #ttgKataloge').val(kataloge);

                // Wenn keine Kataloge ausgewählt worden sind, eine Fehlermeldung anzeigen
                if ($('#ttgKataloge').val() == "") {
                    $('#ttgKatalogError').show();
                    e.preventDefault();
                } else {
                    $("#ttgAjaxLoader").show();
                    $("#ttgKatalogForm").css('opacity', 0.3);
                }
            } // if-else
        });
        /*************** SUBMIT **************/

    } // if

});

function ttgRemoveKatalog(id) {
    $('#ttgCheckedCat' + id).parent().remove();
    $('#ttgKatalogUid' + id).prop("checked", false);
}


function recaptchaCallbackKatalog() {
    $('#ttgSenden').removeAttr('disabled');
}